import { render, staticRenderFns } from "./sign-in.vue?vue&type=template&id=7df815a2"
import script from "./sign-in.vue?vue&type=script&lang=ts"
export * from "./sign-in.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputForm: require('/builds/mates-pay/app/new_reco/reco_for_parent/components/forms/InputForm.vue').default,AlertDialog: require('/builds/mates-pay/app/new_reco/reco_for_parent/components/dialogs/AlertDialog.vue').default,LoadingBar: require('/builds/mates-pay/app/new_reco/reco_for_parent/components/LoadingBar.vue').default})
